import React from 'react';

const values = [
  {
    icon: "fas fa-shield-alt",
    title: "Segurança",
    description: "Priorizamos a segurança em todos os aspectos do trabalho"
  },
  {
    icon: "fas fa-award",
    title: "Qualidade",
    description: "Excelência em todos os serviços prestados"
  },
  {
    icon: "fas fa-users",
    title: "Ética",
    description: "Transparência e honestidade em todas as relações"
  },
  {
    icon: "fas fa-bullseye",
    title: "Ergonomia",
    description: "Foco na utilização correta e ergonômica de equipamentos"
  }
];

const qualifications = [
  "Engenharia da Computação",
  "Engenharia de Segurança do Trabalho",
  "Engenharia de Software",
  "Registro CREA-SP/CONFEA",
  "Instrutores Habilitados em Segurança do Trabalho"
];

const images = [
  { src: "/images/tr1.jpeg", alt: "Instalação 1" },
  { src: "/images/tr2.jpeg", alt: "Instalação 2" },
  { src: "/images/tr3.jpeg", alt: "Instalação 3" },
  { src: "/images/trex3.jpeg", alt: "Instalação 4" }
];

const featuredProducts = [
  {
    href: "https://produto.mercadolivre.com.br/MLB-4113945565-motosserra-husqvarna-bateria540ixpsem-bateria-e-carregador-_JM",
    imgSrc: "/images/bateria/bateria5.jpg",
    imgAlt: "Motosserra Husqvarna Bateria 540iXP",
    title: "Motosserra Husqvarna 540iXP",
    description: "Motosserra profissional à bateria, alto desempenho e sustentabilidade.",
    subtitle: "Motosserra à Bateria 540iXP"
  },
  {
    href: "https://produto.mercadolivre.com.br/MLB-4093622089-motosserra-a-bateria-120i-_JM",
    imgSrc: "/images/bateria/bateria1.jpg",
    imgAlt: "Motosserra Husqvarna Bateria 120i",
    title: "Motosserra Husqvarna 120i",
    description: "Motosserra leve, silenciosa e eficiente para uso doméstico e profissional.",
    subtitle: "Motosserra à Bateria 120i"
  },
  {
    href: "https://produto.mercadolivre.com.br/MLB-5483800074-soprador-a-bateria-120ib-bateria-e-carregador-no-incluso-_JM",
    imgSrc: "/images/bateria/bateria2.jpg",
    imgAlt: "Soprador Husqvarna 120iB",
    title: "Soprador Husqvarna 120iB",
    description: "Soprador à bateria leve, potente e fácil de usar para limpeza de áreas externas.",
    subtitle: "Soprador à Bateria 120iB"
  },
  {
    href: "https://produto.mercadolivre.com.br/MLB-5483937460-rocadeira-a-bateria-535irx-husqvarna-_JM",
    imgSrc: "/images/bateria/bateria4.jpg",
    imgAlt: "Roçadeira Husqvarna 535iRX",
    title: "Roçadeira Husqvarna 535iRX",
    description: "Roçadeira à bateria profissional, alto desempenho e ergonomia.",
    subtitle: "Roçadeira à Bateria 535iRX"
  }
];

const About = () => (
  <div className="pt-24 bg-gray-100">
    {/* Hero Section */}
    <section className="py-16 bg-husqvarna-light-gray text-center">
      <h1 className="text-5xl font-bold text-husqvarna-dark-gray mb-6">Sobre a 3E Máquinas</h1>
      <p className="text-xl text-husqvarna-dark-gray/80 max-w-2xl mx-auto">
        Com mais de 25 anos de tradição em manutenção de máquinas, expandimos nossa atuação para treinamentos e perícias, unindo experiência e inovação.
      </p>
    </section>

    {/* Imagens das Instalações */}
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-husqvarna-orange mb-8 text-center">Nossas Instalações</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
          {images.map((img) => (
            <div key={img.src} className="rounded-lg overflow-hidden shadow">
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-56 object-cover"
                onError={e => { e.target.src = "https://via.placeholder.com/400x300?text=Imagem+Indisponível"; }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Missão e História */}
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <h2 className="text-4xl font-bold text-husqvarna-dark-gray mb-6">Nossa História e Missão</h2>
          <p className="text-lg text-husqvarna-dark-gray/80 mb-6">
            A 3E Máquinas nasceu da paixão por equipamentos de alta performance. Há mais de 25 anos, somos referência em manutenção e representação de marcas consagradas como a Husqvarna. Em 2022, iniciamos um novo capítulo com nossa área de treinamentos e perícias, que hoje completa 3 anos de sucesso.
          </p>
          <p className="text-husqvarna-dark-gray/80">
            Nossa missão é "através da segurança e correta utilização das máquinas Husqvarna, melhorar a qualidade do trabalho através da ERGONOMIA", unindo nossa vasta experiência em manutenção com o conhecimento técnico em segurança.
          </p>
          <div className="grid grid-cols-2 gap-6 mt-8">
            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <h3 className="text-2xl font-bold text-husqvarna-orange mb-2">25+</h3>
              <p className="text-sm text-husqvarna-dark-gray">Anos em Manutenção</p>
            </div>
            <div className="text-center p-4 bg-gray-50 rounded-lg">
              <h3 className="text-2xl font-bold text-husqvarna-orange mb-2">3+</h3>
              <p className="text-sm text-husqvarna-dark-gray">Anos em Treinamentos</p>
            </div>
          </div>
        </div>
        <div className="rounded-2xl overflow-hidden shadow-lg flex items-center justify-center bg-white">
          <img
            src="/images/frente3e.jpeg"
            alt="Fachada da loja 3E Máquinas"
            className="w-full max-w-xl h-auto object-contain"
            style={{ aspectRatio: "4/3", background: "#fff" }}
            onError={e => { e.target.src = "https://via.placeholder.com/400x300?text=Imagem+Indisponível"; }}
          />
        </div>
      </div>
    </section>

    {/* Valores */}
    <section className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-husqvarna-dark-gray mb-4 text-center">Nossos Valores</h2>
        <p className="text-xl text-husqvarna-dark-gray/80 max-w-3xl mx-auto mb-10 text-center">
          Os princípios que norteiam nossa atuação e garantem a excelência em todos os serviços
        </p>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value) => (
            <div key={value.title} className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 text-center">
              <div className="w-16 h-16 bg-husqvarna-orange rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${value.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-xl font-semibold text-husqvarna-dark-gray mb-3">{value.title}</h3>
              <p className="text-husqvarna-dark-gray/80">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Equipe e Qualificações */}
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4 grid lg:grid-cols-2 gap-12 items-center">
        <div className="rounded-2xl overflow-hidden shadow-lg">
          <img
            src="/images/engenheiro3e.jpeg"
            alt="Engenheiro da 3E Máquinas"
            className="w-full h-96 object-cover"
            onError={e => { e.target.src = "/images/equipe.jpeg"; }}
          />
        </div>
        <div>
          <h2 className="text-4xl font-bold text-husqvarna-dark-gray mb-6">Nossa Equipe</h2>
          <p className="text-lg text-husqvarna-dark-gray/80 mb-6">
            Profissionais altamente qualificados com sólida formação acadêmica e vasta experiência prática em Engenharia de Segurança do Trabalho, Perícias Trabalhistas, Venda e Manutenção de Máquinas e Ferramentas Agro Leve.
          </p>
          <h3 className="text-xl font-semibold text-husqvarna-dark-gray mb-4">Qualificações:</h3>
          <ul className="space-y-2">
            {qualifications.map((q) => (
              <li key={q} className="flex items-center">
                <span className="inline-block w-4 h-4 bg-green-500 rounded-full mr-2"></span>
                <span className="text-husqvarna-dark-gray/80">{q}</span>
              </li>
            ))}
          </ul>
          <div className="bg-gray-50 rounded-lg p-6 mt-6">
            <div className="flex items-center space-x-3 mb-3">
              <i className="fas fa-briefcase text-husqvarna-orange text-xl"></i>
              <h4 className="text-lg font-semibold text-husqvarna-dark-gray">Especialização</h4>
            </div>
            <p className="text-husqvarna-dark-gray/80">
              Especialista em NR-12 (Segurança no Trabalho em Máquinas e Equipamentos) com foco em treinamentos práticos e teóricos para uso seguro de equipamentos Husqvarna.
            </p>
          </div>
        </div>
      </div>
    </section>

    {/* Parceria */}
    <section className="py-16" style={{ backgroundColor: "#ff6600" }}>
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-4xl font-bold text-white mb-6">
          Parceria Oficial Husqvarna do Brasil
        </h2>
        <p className="text-xl text-white mb-8">
          Somos orgulhosamente parceiros oficiais da Husqvarna do Brasil, oferecendo treinamentos certificados e especializados em equipamentos da marca líder mundial em soluções para floresta, parque e jardim.
        </p>
        <div className="flex justify-center">
          <img
            alt="Showroom de equipamentos Husqvarna na 3E Máquinas"
            className="rounded-lg shadow-lg"
            src="/images/standbateria.jpeg"
            style={{ background: "#fff", width: "1196px", height: "1600px", objectFit: "cover", maxWidth: "100%" }}
            onError={e => { e.target.src = "https://via.placeholder.com/400x300?text=Imagem+Indisponível"; }}
          />
        </div>
      </div>
    </section>

    {/* Produtos em Destaque */}
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-husqvarna-orange mb-8 text-center">Produtos em Destaque</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {featuredProducts.map((product) => (
            <div key={product.title} className="bg-white p-6 rounded-lg shadow-lg text-center product-card">
              <a
                href={product.href}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: "block" }}
              >
                <img
                  src={product.imgSrc}
                  alt={product.imgAlt}
                  className="object-contain w-full h-full"
                  style={{ maxHeight: "200px", maxWidth: "100%" }}
                />
              </a>
              <h4 className="text-xl font-semibold mb-2 text-husqvarna-dark-gray">{product.title}</h4>
              <p className="text-md text-gray-600 mb-4">{product.description}</p>
              <span className="inline-block bg-green-500 text-white text-sm px-3 py-1 rounded-full">Sustentável</span>
              <div className="mt-2 text-center font-semibold text-husqvarna-dark-gray text-base">
                {product.subtitle}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default About;
